// extracted by mini-css-extract-plugin
export default {"wrapper":"generic-modal-wrapper_wrapper__+oGE1","title":"generic-modal-wrapper_title__-eqjo","cursorDisabled":"generic-modal-wrapper_cursorDisabled__eBExE"};